import $ from 'jquery';
import DataTable from 'datatables.net';

const currentZipsCount = document.querySelector(".currentZipsCount");
const newZipsCount = document.querySelector(".newZipsCount");

const setCounts = () => {
    const currentAmountOfZipsInList = document.querySelectorAll(".user-postal-code-number").length;
    const currentZipsNotSubscribedTo = document.querySelectorAll(".user-postal-code-number.not-subscribed").length;
    if (currentAmountOfZipsInList > 0 && currentZipsCount) {
        currentZipsCount.innerText = "There are currently " + currentAmountOfZipsInList + " zip codes in your list";
    }
    if (currentZipsNotSubscribedTo > 0 && newZipsCount) {
        newZipsCount.innerText = "If you update, you will add " + currentZipsNotSubscribedTo + " zip codes to your list";
    }
}

$(function() {
    const $profile = $('.profile');
    const $profileNav = $('.profile-nav');
    setCounts();
    if ($profile.length) {
        const $tabLinks = $profileNav.find('.profile-tabs li');
        const $tabSections = $profile.find('.profile-edit-section');

        // Listen to click events on the tabLinks
        $tabLinks.click(function(e) {
            const $target = $(e.target);
            // If this tab is already choosen, return
            if ($target.hasClass('active')) {
                return;
            }

            const tab = $target.data('tab');

            changeSection(tab);
            historyUpdate(tab);
        });

        // Listen to popState so the history can function properly
        window.addEventListener('popstate', function(e) {
            var tab = e.state;

            if (tab != null) {
                changeSection(tab);
            }
        });

        /**
        * Changes the section of the profile
        * @param tab slug of the new tab to move to
        */
        function changeSection(tab) {
            $tabLinks.removeClass('active');
            $tabLinks.filter('[data-tab=' + tab + ']').addClass('active');

            // Make section active
            $tabSections.removeClass('active');
            $tabSections.filter('[data-tab=' + tab + ']').addClass('active');

            // Quick resize to make sure things draw properly
            $(window).resize();
        }

        /**
         * Pushes State to History with Query
         */
        function historyUpdate(tab) {
            // Push State with Query String, allowing things like bookmarking and all that happiness
            if (history.pushState) {
                var url = window.location.protocol
                + "//"
                + window.location.host
                + window.location.pathname
                + '?tab=' + tab;
                history.pushState(tab, $(document).find('title').text(), url);
            }
        }
    }



    /**
     * Postal Code List Manipulations
     */
    const $postalCodeList = $('.user-postal-code-list');
    const $postalCodeAdd = $('.user-postal-code-add');

    if ($postalCodeList.length && $postalCodeAdd.length) {
        const $newPostalField = $postalCodeAdd.find('input[name="postalCodeAddon"]');
        const $newPostalSubmit = $postalCodeAdd.find('input[type="submit"]');
        const $postalCodeUpdate = $postalCodeList.siblings('input[type="submit"]');

        function disableClick($element) {
            $element.addClass('disabled');
            $element.attr('disabled', 'disabled');
        }

        function enableClick($element) {
            $element.removeClass('disabled');
            $element.removeAttr('disabled');
        }

        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);

        if (!urlParams.get('zipRadius') && !urlParams.get('stateFilter')) {
            disableClick($postalCodeUpdate);
        }

        //TODO: Need to validate this zipcode...
        $newPostalSubmit.on('click', function(e) {
            const newCode = $newPostalField.val();
            if ($postalCodeList.find('input[value="' + newCode + '"]').length) {
                alert('You already have that Zip Code, please choose another');
            } else {
                let $element = $(
                    '<div class="user-postal-code">' +
                    '<input type="hidden" name="postalCodes[]" value="' + newCode + '" />' +
                    '<div class="user-postal-code-number not-subscribed">' +
                    newCode +
                    '</div>' +
                    '<a href="" class="user-postal-code-remove">' +
                    'Remove' +
                    '</a>' +
                    '</div>'
                );

                $postalCodeList.append($element);
                enableClick($postalCodeUpdate);
            }
            setCounts();
            return false;
        });

        $postalCodeList.on('click', '.user-postal-code-remove', function(e) {
            $(e.target).parent('.user-postal-code').remove();
            enableClick($postalCodeUpdate);
            setCounts();
            return false; // Stop propogation and default event
        });
    }

    /**
    * Rebate Tables
    */
    const $rebateTable = $('#rebate-table');
    if ($rebateTable.length) {
        $rebateTable.DataTable({
            'scrollX': true,
            'order':[0, 'desc'],
            'pagingType': 'numbers',
            'pageLength': 15,
        });
    }
});
